import type { ConsoleProviderConfig } from "../../schema/provider-core.js";
import type { TelemetryProviderDefinition } from "../types.js";

export function Console(
  config: Partial<Omit<ConsoleProviderConfig, "type">> = {},
): TelemetryProviderDefinition {
  return {
    id: config.id ?? "console",
    type: "console",
    toProviderConfig: () => ({
      type: "console",
      level: config.level ?? "error",
      runtime: config.runtime ?? "both",
      id: config.id,
    }),
  };
}
